// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2OOwR","header":"ClearentDisclaimer_header__3dCn2","inner":"ClearentDisclaimer_inner__1siLk"};